<template>
  <v-flex>
    <v-progress-linear
      v-if="isTableLoading"
      class="ma-0"
      height="2"
      indeterminate/>
    <v-list
      v-if="!isCompanyExist"
      two-line
      subheader>
      <v-list-tile avatar>
        <v-list-tile-content>
          <v-list-tile-title> {{ $t('noInfoYet') }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-data-table
      v-else
      :items="log"
      :rows-per-page-items="[15]"
      :total-items="paginationTotal"
      :pagination.sync="pagination"
      hide-headers
    >
      <template
        slot="items"
        slot-scope="props"
      >
        <td class="pa-2">
          <company-log-entry :item="props.item" />
        </td>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'
import PaginationApi from '@/api/PaginationApi'
import Pagination from '@/components/global-components/pagination/Pagination'
import CompanyLogEntry from '@/components/routes/companies/CompanyLogEntry'

export default {
  name: 'CompanyLog',
  components: { CompanyLogEntry, Pagination },
  props: ['companyId'],
  data () {
    return {
      pagination: {},
      paginationTotal: null,
      isTableLoading: false,
      url: `/company/logs`,
      log: []
    }
  },
  computed: {
    ...mapGetters('user', ['getUser']),
    isCompanyExist () {
      return this.getUser.has_company
    },
    query () {
      if (this.$can('read', 'AllLogs')) {
        return [`company_id=${this.companyId}`]
      }
    }
  },
  methods: {
    async getPaginatedData () {
      this.isTableLoading = true
      try {
        const response = await PaginationApi.getPaginatedData(this.url, [`page=${this.pagination.page}`])
        this.paginationTotal = response.total
        this.log = response.data
      } catch (e) {
        this.$notification(e)
      }
      this.isTableLoading = false
    }
  },
  watch: {
    pagination: {
      handler: `getPaginatedData`
    }
  },
  i18n: {
    messages: {
      en: {
        noInfoYet: 'No information yet'
      },
      tr: {
        noInfoYet: 'Henüz bir bilgi bulunmamaktadır'
      },
      de: {
        noInfoYet: 'Bisher keine Informationen'
      },
      ru: {
        noInfoYet: 'Пока нет информации'
      }
    }
  }
}
</script>

<style scoped>

</style>
